import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { usePreviewContext } from 'context/previewContext'
import LandingPage from 'pages/landingPage/LandingPage'

import { GoogleCallback } from './view/GoogleCallback/GoogleCallback'
import { RecoverAccount } from './view/RecoverAccount/RecoverAccount'
import { ResetPassword } from './view/ResetPassword/ResetPassword'
import { TwitterLogin } from './view/TwitterLogin'
import { Verify } from './view/Verify/Verify'

import './_auth.scss'
import './view/Login/_login.scss'
import './view/Register/_register.scss'
import './view/RecoverAccount/_recoverAccount.scss'
import './view/ResetPassword/_resetPassword.scss'
import './view/Verify/_verify.scss'
import './view/NotLogged/_notLogged.scss'

export const Auth = () => {
    const { type } = useParams<{ type: string }>()
    const { resetPreviewState } = usePreviewContext()

    useEffect(() => {
        resetPreviewState()
    }, [])

    const renderComponent = () => {
        switch (type) {
            // case 'login':
            //     return <Login />
            // case 'signup':
            //     return <Register />
            case 'recover':
                return <RecoverAccount />
            case 'reset-password-email':
                return <RecoverAccount title='Reset password' />
            case 'verify':
                return <Verify />
            case 'reset-password':
                return <ResetPassword />
            case 'login-twitter':
                return <TwitterLogin />
            case 'google-callback':
                return <GoogleCallback />
            default:
                return <LandingPage/>
            // return <NotLogged />
        }
    }

    return renderComponent()
}
